import { render, staticRenderFns } from "./AddPrivilege.vue?vue&type=template&id=2010114d"
import script from "./AddPrivilege.vue?vue&type=script&lang=js"
export * from "./AddPrivilege.vue?vue&type=script&lang=js"
import style0 from "./AddPrivilege.vue?vue&type=style&index=0&id=2010114d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports